import React, { useState, useEffect } from "react";
import { useTranslation } from 'react-i18next';
import "../FeatureManager.css";
import { saveSessionData, loadSessionData } from "../../utils/sessionStorageClient";

const LOCAL_STORAGE_KEY = "sessionComment";

const SessionCommentPanel = () => {
  const { t } = useTranslation();
  const [comment, setComment] = useState("");
  const [savedComment, setSavedComment] = useState("");
  const [isEditing, setIsEditing] = useState(false);

  // Charger le commentaire depuis MongoDB ou localStorage
  useEffect(() => {
    loadSessionData(LOCAL_STORAGE_KEY).then((stored) => {
      if (stored) {
        setComment(stored);
        setSavedComment(stored);
      }
    });
  }, []);

  // Sauvegarder explicitement
  const handleSave = async () => {
    await saveSessionData(LOCAL_STORAGE_KEY, comment);
    setSavedComment(comment);
    setIsEditing(false);
  };

  const handleEdit = () => {
    setIsEditing(true);
  };

  return (
    <div className="section-create-node" style={{ marginBottom: 24 }}>
      <div className="section-header-create-node">
        <span className="section-icon-create-node-emoji" role="img" aria-label="Comment">💬</span>
        <span className="section-title-create-node">{t('sessionCommentPanel.title')}</span>
      </div>
      {isEditing ? (
        <>
          <textarea
            className="comment-input"
            style={{ width: "100%", minHeight: 80, marginBottom: 12 }}
            placeholder={t('sessionCommentPanel.placeholder')}
            value={comment}
            onChange={e => setComment(e.target.value)}
            autoFocus
          />
          <button className="send-comment-btn" style={{ marginRight: 8 }} onClick={handleSave}>
            {t('sessionCommentPanel.save')}
          </button>
          <button className="send-comment-btn" onClick={() => { setComment(savedComment); setIsEditing(false); }}>
            {t('sessionCommentPanel.cancel')}
          </button>
        </>
      ) : (
        <div style={{ minHeight: 60, marginBottom: 12, whiteSpace: 'pre-line', color: '#334155', fontSize: 16 }}>
          {savedComment || <span style={{ color: '#94a3b8' }}>({t('sessionCommentPanel.noComment')})</span>}
        </div>
      )}
      {!isEditing && (
        <button className="send-comment-btn" onClick={handleEdit}>
          {savedComment ? t('sessionCommentPanel.edit') : t('sessionCommentPanel.add')}
        </button>
      )}
    </div>
  );
};

export default SessionCommentPanel;
